module.exports = __webpack_public_path__ + "static/media/nc.846211de.svg";